import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import Footer from "./Footer";
import Header from "./Header";
import siteConfig from "../config/siteConfig";
import "../css/contactus.scss";

function Contact() {
  const [formData, setFormData] = useState({ firstName: "", lastName: "", email: "", subject: "", message: "" });
  const [errors, setErrors] = useState({});

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({ ...current, [name]: value }));
    if (errors[name]) setErrors((current) => ({ ...current, [name]: "" }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const next = {};
    if (!formData.firstName.trim()) next.firstName = "First name is required.";
    if (!formData.lastName.trim()) next.lastName = "Last name is required.";
    if (!/^\S+@\S+\.\S+$/.test(formData.email)) next.email = "Enter a valid email address.";
    if (!formData.subject) next.subject = "Choose a subject.";
    if (formData.message.trim().length < 10) next.message = "Add enough detail for us to identify the question.";
    if (Object.keys(next).length) { setErrors(next); return; }

    const subject = encodeURIComponent(`${formData.subject} — ${formData.firstName} ${formData.lastName}`);
    const body = encodeURIComponent(`Reply to: ${formData.email}\n\n${formData.message}`);
    window.location.href = `mailto:${siteConfig.contact.email}?subject=${subject}&body=${body}`;
  };

  return (
    <div className="contact">
      <Header />
      <main className="service-page contact-page">
        <aside className="service-page__nav">
          <span>Help &amp; information</span>
          <Link className="is-active" to="/contact">Contact us</Link>
          <Link to="/shipping">Shipping</Link>
          <Link to="/returns">Returns</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/contact-policy">Contact policy</Link>
        </aside>

        <section className="contact-page__content">
          <header><span className="eyebrow">Customer care</span><h1>How can we help?</h1><p>Ask about fit, a payment result, delivery, a return, data, or accessibility. The form opens an email draft addressed to the verified support inbox.</p></header>
          <form className="contact-form" onSubmit={handleSubmit} noValidate>
            <div className="contact-form__row">
              <ContactField label="First name" name="firstName" value={formData.firstName} error={errors.firstName} onChange={handleInputChange} />
              <ContactField label="Last name" name="lastName" value={formData.lastName} error={errors.lastName} onChange={handleInputChange} />
            </div>
            <ContactField label="Reply email" name="email" type="email" value={formData.email} error={errors.email} onChange={handleInputChange} />
            <label className={errors.subject ? "has-error" : ""}><span>Subject</span><select name="subject" value={formData.subject} onChange={handleInputChange}><option value="">Choose one</option><option>Product and fit</option><option>Order or payment</option><option>Delivery or return</option><option>Privacy or accessibility</option><option>Policy question</option></select>{errors.subject && <small>{errors.subject}</small>}</label>
            <label className={errors.message ? "has-error" : ""}><span>Message</span><textarea name="message" value={formData.message} onChange={handleInputChange} rows="7" placeholder="Include an order reference when relevant, but never full card details." />{errors.message && <small>{errors.message}</small>}</label>
            <button className="app-button" type="submit">Open email draft <FiArrowRight /></button>
          </form>

          <div className="contact-page__details">
            <section><h2>Customer care</h2><a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a><address>{siteConfig.contact.address}</address><p>Use the checkout email and order reference for purchase questions.</p></section>
            <section><h2>Operating country</h2><p>{siteConfig.operatingRegion}</p></section>
            <section><h2>Policies</h2><Link to="/policies">Open the complete policy guide</Link><p>Find the exact evidence and timing needed for each request.</p></section>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

function ContactField({ label, name, value, error, onChange, type = "text" }) {
  return <label className={error ? "has-error" : ""}><span>{label}</span><input type={type} name={name} value={value} onChange={onChange} placeholder={label} />{error && <small>{error}</small>}</label>;
}

export default Contact;
